import * as Immutable from "immutable";
export default class MongoDBDataAdapterEntry {
  constructor(id, dataAdapterId, key, values, ttl, ttl_unit, expire_after) {
    this._value = { id, dataAdapterId, key, values, ttl, ttl_unit, expire_after };
  }
  get id() {
    return this._value.id;
  }
  get dataAdapterId() {
    return this._value.dataAdapterId;
  }
  get key() {
    return this._value.key;
  }
  get values() {
    return this._value.values;
  }
  get ttl() {
    return this._value.ttl;
  }
  get ttlUnit() {
    return this._value.ttl_unit;
  }
  get expire_after() {
    return this._value.expire_after;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(id, dataAdapterId, key, value, ttl, ttl_unit, expire_after) {
    return new MongoDBDataAdapterEntry(id, dataAdapterId, key, value, ttl, ttl_unit, expire_after);
  }
  static builder() {
    return new Builder();
  }
  toJSON() {
    const { id, dataAdapterId, key, values, ttl, ttl_unit, expire_after } = this._value;
    return {
      id,
      data_adapter_id: dataAdapterId,
      key,
      values,
      ttl,
      ttl_unit,
      expire_after
    };
  }
  static fromJSON(_value) {
    const { id, data_adapter_id: dataAdapterId, key, values, ttl, ttl_unit, expire_after } = _value;
    return MongoDBDataAdapterEntry.create(id, dataAdapterId, key, values, ttl, ttl_unit, expire_after);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this._value = value;
  }
  id(value) {
    return new Builder(this._value.set("id", value));
  }
  dataAdapterId(value) {
    return new Builder(this._value.set("dataAdapterId", value));
  }
  key(value) {
    return new Builder(this._value.set("key", value));
  }
  values(values) {
    return new Builder(this._value.set("values", values));
  }
  ttl(value) {
    return new Builder(this._value.set("ttl", value));
  }
  ttl_unit(value) {
    return new Builder(this._value.set("ttl_unit", value));
  }
  expire_after(value) {
    return new Builder(this._value.set("expire_after", value));
  }
  build() {
    const { id, dataAdapterId, key, values, ttl, ttl_unit, expire_after } = this._value.toObject();
    return new MongoDBDataAdapterEntry(id, dataAdapterId, key, values, ttl, ttl_unit, expire_after);
  }
}
